import {
  Dialog,
  DialogSurface,
  Button,
  DialogTitle,
  DialogBody,
} from "@fluentui/react-components";
import { Building32Filled, Person32Filled } from "@fluentui/react-icons";
import { useNavigate } from "react-router";

function CreateContact({
  open,
  toggleContactForm,
}: {
  open: boolean;
  toggleContactForm: (value: boolean) => void;
}) {
  const navigate = useNavigate();

  const handleOpenCompanyForm = () => {
    toggleContactForm(false);
    navigate("/contacts/new/company");
  };

  const handleOpenPrivateForm = () => {
    toggleContactForm(false);
    navigate("/contacts/new/private");
  };

  return (
    <Dialog open={open} onOpenChange={(_, d) => toggleContactForm(d.open)}>
      <DialogSurface>
        <DialogTitle
          style={{
            padding: "20px 24px 24px 24px",
            fontSize: 20,
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          Was möchten Sie anlegen?
        </DialogTitle>
        <DialogBody style={{ display: "block" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", padding: "10px 0 20px 0" }}>
            <Button
              style={{ flexDirection: "column", height: "auto", padding: "16px" }}
              size="large"
              icon={<Building32Filled style={{ fontSize: "48px" }} />}
              onClick={handleOpenCompanyForm}
            >
              Firmenkontakt
            </Button>
            <Button
              style={{ flexDirection: "column", height: "auto", padding: "16px" }}
              size="large"
              icon={<Person32Filled style={{ fontSize: "48px" }} />}
              onClick={handleOpenPrivateForm}
            >
              Privatkontakt
            </Button>
          </div>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default CreateContact;
